 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLE_FULL from '@/components/Text/title_full'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTDEDICATION from '@/components/Text/dedication'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/Acknowledgments'
 import TEXTINTRODUCTION from '@/components/Text/Introduction'
 import TEXTTITLE_HALF from '@/components/Text/title_half'
 import TEXTPART1 from '@/components/Text/part1'
 import TEXT01 from '@/components/Text/01'
 import TEXT02 from '@/components/Text/02'
 import TEXT03 from '@/components/Text/03'
 import TEXT04 from '@/components/Text/04'
 import TEXT05 from '@/components/Text/05'
 import TEXT06 from '@/components/Text/06'
 import TEXTPART2 from '@/components/Text/part2'
 import TEXT07 from '@/components/Text/07'
 import TEXT08 from '@/components/Text/08'
 import TEXT09 from '@/components/Text/09'
 import TEXT10 from '@/components/Text/10'
 import TEXT11 from '@/components/Text/11'
 import TEXT12 from '@/components/Text/12'
 import TEXTPART3 from '@/components/Text/part3'
 import TEXT13 from '@/components/Text/13'
 import TEXT14 from '@/components/Text/14'
 import TEXT15 from '@/components/Text/15'
 import TEXT16 from '@/components/Text/16'
 import TEXT17 from '@/components/Text/17'
 import LOVE_2 from '@/components/love_2'
 import TEXTAPENDIXA from '@/components/Text/ApendixA'
 import TEXTAPENDIXB from '@/components/Text/ApendixB'
 import TEXTAPENDIXC from '@/components/Text/ApendixC'
 import TEXTNOTES from '@/components/Text/Notes'
 import TEXTSELECTEDBIBLIOGRAPHY from '@/components/Text/SelectedBibliography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/Acknowledgments",
 			"name" : "Text/Acknowledgments",
 			"component" : TEXTACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/Text/Introduction",
 			"name" : "Text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/title_half",
 			"name" : "Text/title_half",
 			"component" : TEXTTITLE_HALF
 		},
 		{
 			"path" : "/Text/part1",
 			"name" : "Text/part1",
 			"component" : TEXTPART1
 		},
 		{
 			"path" : "/Text/01",
 			"name" : "Text/01",
 			"component" : TEXT01
 		},
 		{
 			"path" : "/Text/02",
 			"name" : "Text/02",
 			"component" : TEXT02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js